export default __webpack_public_path__ + "static/media/petcloud-text.c165a52c.svg";